import { Component, OnInit, OnDestroy }  from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { TAFBookB4Service } from './taf-book-b4.service';
import { ITAFBookB4 } from './taf-book-b4-list';

import {DataTable} from 'primeng/primeng';
import {Column} from 'primeng/primeng';
import {Header} from 'primeng/primeng';
import {Button} from 'primeng/primeng';


@Component({
    //templateUrl: 'app/system-management/tafbooks/taf-book-b4/taf-book-b4.component.html',
    template: require('./taf-book-b4.component.html'),
    directives: [ROUTER_DIRECTIVES,DataTable,Column, Header],
    
})

export class TAFBookB4Component implements OnInit, OnDestroy{
    pageTitle: string = 'TAF BOOK b4';
    errorMessage: string;
    tafBookB4Arr: ITAFBookB4;
   
    constructor(private route: ActivatedRoute,
                private router: Router,
                private _tafBookB4Service: TAFBookB4Service) {
                    
    }

    ngOnInit(): void{
        this._tafBookB4Service.getTAFBookB4()
         .subscribe(
                tafBookB4Arr => this.tafBookB4Arr = tafBookB4Arr,
                error =>  this.errorMessage = <any>error);
    }

    ngOnDestroy() {
        //alert("onDestroy");
        //this.sub.unsubscribe();
   }
   
}


/** WEBPACK FOOTER **
 ** ./app/system-management/tafbooks/taf-book-b4/taf-book-b4.component.ts
 **/